<template>
  <section class="ut-p-6 prospect-stage-question">
    <div class="reminder-date">
      <svg-loader :name="'icon-calendar'" :width="16" class="ut-m-0" />
      <p>Prospect removed on {{ $helpers.convertFromUTC(formateDate, 'D MMM YYYY') }}</p>
    </div>
    <router-link tag="button" class="btn btn-green-inverted confirm-btn"
                 :to="{ name: 'prospecting' ,
                          params : {ak: $route.params.ak } }" >
          See all prospects
      </router-link>
  </section>
</template>

<script>
import SvgLoader from '@oa-vue/svg-loader/SvgLoader.vue';

export default {
  name: 'ProspectStageQuesProspectRemoved',
  components: {
    SvgLoader,
  },
  props: {
    prospect: {
      type: Object,
      required: true,
    },
    userid: {
      required: true,
    },
  },
  data() {
    return {
      gacategory: 'Prospecting Tool Agent portal',
      selectedAnswer: null,
      answers: [
        {
          id: 'did-you-follow-up-yes',
          value: true,
          label: 'Yes',
        },
        {
          id: 'did-you-follow-up-no-remove-prospect',
          value: false,
          label: 'No, remove this prospect',
        },
      ],
    };
  },
  computed: {
    formateDate() {
      return this.$helpers.formatDateNormal(this.prospect.stage.createdDate, 'D MMM, YYYY HH:mm');
    },
  },
  created() {},
  methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import "@/assets/styles/prospect-stage-questions";
</style>
